import type { ComponentPropsWithoutRef } from 'react';
import ValuePickerWrapper from './ValuePickerWrapper';

interface InputWithValuePickerProps extends ComponentPropsWithoutRef<typeof ValuePickerWrapper> {
    placeholder?: string;
    title: string;
    type?: string;
    validationMessage?: string;
}

const InputWithValuePicker = ({
    id,
    label,
    isRequired = false,
    testId,
    value,
    placeholder = '',
    title,
    type = 'text',
    container,
    description,
    onChangeAsValueReference,
    validationMessage,
}: InputWithValuePickerProps) => {
    return (
        <ValuePickerWrapper
            container={container}
            id={id}
            label={label}
            onChangeAsValueReference={onChangeAsValueReference}
            testId={testId}
            value={value}
            description={description}
            isRequired={isRequired}
            contentType={type === 'number' ? 'ContentNumber' : 'ContentString'}
            validationMessage={validationMessage}
        >
            <input
                placeholder={placeholder}
                className="form-control"
                id={id}
                type={type}
                value={typeof value === 'string' || typeof value === 'number' ? String(value) : ''}
                onChange={({ target: { value } }) => {
                    onChangeAsValueReference(value);
                }}
                title={title}
                required={isRequired}
            />
        </ValuePickerWrapper>
    );
};

export default InputWithValuePicker;
